export default __webpack_public_path__ + "static/media/WorkSans-Medium.3515918a.ttf";